import {useEffect, useMemo} from "react";
import {User} from "shared/types/VaultTypes";
import {AT} from "src/core/vault/ActionTypeConstants";

/**
 * user.placementTest is not loaded by default when you load the user. This is because
 * it comes from a separate API request to the placement server, similar to how we fetch
 * student platform data. And placement test info is less critical to the overall application
 * than platform data, so if a certain component needs the placementTest to be loaded, it should
 * call this hook! If the placementTest has already been requested or fetched, we will not make
 * another request.
 */
export const useUserPlacementTestInfo = ({
	user,
	dispatch,
}: {
	user: User;
	dispatch: (action: unknown) => void;
}) => {
	const placementTestInfo = useMemo(() => user.placementTest, [user]);
	useEffect(() => {
		// User is not loaded yet...
		if (!user.userID || !user.platformUserID) {
			return;
		}
		if (placementTestInfo.load === "none") {
			dispatch({type: AT.LOAD_USER_PLATFORM_PLACEMENT_REQUEST});
		}
	}, [user, placementTestInfo, dispatch]);
	return placementTestInfo.load === "done" ? placementTestInfo : undefined;
};
